<template>
  <div id="droppalbe" class="bg ui-droppable">
    <div id="outDiv">
      <div id="apDiv1">
        <input :value="aBill.a1" name="A[0].a1" cname="a1" style="font-weight: bold" />
      </div>
      <div id="apDiv2">
        <input :value="aBill.a2" name="A[0].a2" cname="a2" style="font-weight: bold" class="isNumeric" />
      </div>
      <div id="apDiv3">
        <input :value="aBill.a3" name="A[0].a3" cname="a3" style="font-weight: bold" class="isNumeric" />
      </div>
      <div id="apDiv4">
        <input :value="aBill.a4" name="A[0].a4" cname="a4" style="font-weight: bold" class="isNumeric" />
      </div>
      <div id="apDiv5">
        <input :value="aBill.a5" name="A[0].a5" cname="a5" style="font-weight: bold; text-align: left" />
      </div>

      <div id="apDiv6">
        <input :value="aBill.a6" name="A[0].a6" cname="a6" style="font-weight: bold; text-align: left" />
      </div>
      <div id="apDiv7">
        <input :value="aBill.a7" name="A[0].a7" cname="a7" style="font-weight: bold; text-align: left" />
      </div>
      <div id="apDiv8">
        <input :value="aBill.a8" name="A[0].a8" cname="a8" style="font-weight: bold; text-align: left" />
      </div>
      <div id="apDiv9">
        <input :value="aBill.a9" name="A[0].a9" cname="a9" style="font-weight: bold; text-align: left" />
      </div>

      <div id="apDiv10">
        <input :value="bBill.b1" name="B[0].b1" cname="b1" style="font-weight: bold; text-align: center" />
      </div>
      <div id="apDiv11">
        <input :value="bBill.b2" name="B[0].b2" cname="b2" style="font-weight: bold; text-align: left" />
      </div>
      <div id="apDiv12">
        <input :value="bBill.b3" name="B[0].b3" cname="b3" style="font-weight: bold; text-align: center" />
      </div>
      <div id="apDiv13">
        <input :value="bBill.b4" name="B[0].b4" cname="b4" style="font-weight: bold; text-align: right" />
      </div>
      <div id="apDiv14">
        <input :value="bBill.b5" name="B[0].b5" cname="b5" style="font-weight: bold; text-align: right" />
      </div>
      <div id="apDiv15">
        <input :value="bBill.b6" name="B[0].b6" cname="b6" style="font-weight: bold; text-align: right" />
      </div>
      <div id="apDiv16">
        <input :value="bBill.b7" name="B[0].b7" cname="b7" class="isMoney" style="font-weight: bold" />
      </div>

      <div id="apDiv17">
        <input :value="bBill.b8" name="B[0].b8" cname="b8" style="font-weight: bold; text-align: center" />
      </div>
      <div id="apDiv18">
        <input :value="bBill.b9" name="B[0].b9" cname="b9" style="font-weight: bold; text-align: left" />
      </div>
      <div id="apDiv19">
        <input :value="bBill.b10" name="B[0].b10" cname="b10" style="font-weight: bold; text-align: center" />
      </div>
      <div id="apDiv20">
        <input :value="bBill.b11" name="B[0].b11" cname="b11" style="font-weight: bold; text-align: right" />
      </div>
      <div id="apDiv21">
        <input :value="bBill.b12" name="B[0].b12" cname="b12" style="font-weight: bold; text-align: right" />
      </div>
      <div id="apDiv22">
        <input :value="bBill.b13" name="B[0].b13" cname="b13" style="font-weight: bold; text-align: right" />
      </div>
      <div id="apDiv23">
        <input :value="bBill.b14" name="B[0].b14" cname="b14" class="isMoney" style="font-weight: bold" />
      </div>

      <div id="apDiv24">
        <input :value="bBill.b15" name="B[0].b15" cname="b15" style="font-weight: bold; text-align: center" />
      </div>
      <div id="apDiv25">
        <input :value="bBill.b16" name="B[0].b16" cname="b16" style="font-weight: bold; text-align: left" />
      </div>
      <div id="apDiv26">
        <input :value="bBill.b17" name="B[0].b17" cname="b17" style="font-weight: bold; text-align: center" />
      </div>
      <div id="apDiv27">
        <input :value="bBill.b18" name="B[0].b18" cname="b18" style="font-weight: bold; text-align: right" />
      </div>
      <div id="apDiv28">
        <input :value="bBill.b19" name="B[0].b19" cname="b19" style="font-weight: bold; text-align: right" />
      </div>
      <div id="apDiv29">
        <input :value="bBill.b20" name="B[0].b20" cname="b20" style="font-weight: bold; text-align: right" />
      </div>
      <div id="apDiv30">
        <input :value="bBill.b21" name="B[0].b21" cname="b21" class="isMoney" style="font-weight: bold" />
      </div>

      <div id="apDiv31">
        <input :value="bBill.b22" name="B[0].b22" cname="b22" style="font-weight: bold; text-align: center" />
      </div>
      <div id="apDiv32">
        <input :value="bBill.b23" name="B[0].b23" cname="b23" style="font-weight: bold; text-align: left" />
      </div>
      <div id="apDiv33">
        <input :value="bBill.b24" name="B[0].b24" cname="b24" style="font-weight: bold; text-align: center" />
      </div>
      <div id="apDiv34">
        <input :value="bBill.b25" name="B[0].b25" cname="b25" style="font-weight: bold; text-align: right" />
      </div>
      <div id="apDiv35">
        <input :value="bBill.b26" name="B[0].b26" cname="b26" style="font-weight: bold; text-align: right" />
      </div>
      <div id="apDiv36">
        <input :value="bBill.b27" name="B[0].b27" cname="b27" style="font-weight: bold; text-align: right" />
      </div>
      <div id="apDiv37">
        <input :value="bBill.b28" name="B[0].b28" cname="b28" class="isMoney" style="font-weight: bold" />
      </div>

      <div id="apDiv38">
        <input :value="bBill.b29" name="B[0].b29" cname="b29" style="font-weight: bold; text-align: center" />
      </div>
      <div id="apDiv39">
        <input :value="bBill.b30" name="B[0].b30" cname="b30" style="font-weight: bold; text-align: right" />
      </div>
      <div id="apDiv40">
        <input :value="bBill.b31" name="B[0].b31" cname="b31" style="font-weight: bold; text-align: right" />
      </div>
      <div id="apDiv41">
        <input :value="bBill.b32" name="B[0].b32" cname="b32" style="font-weight: bold; text-align: right" />
      </div>
      <div id="apDiv42">
        <input :value="bBill.b33" name="B[0].b33" cname="b33" class="isMoney" style="font-weight: bold" />
      </div>

      <div id="apDiv43">
        <input :value="aBill.a10" name="A[0].a10" cname="a10" style="font-weight: bold; text-align: left" />
      </div>
      <div id="apDiv44">
        <input :value="aBill.a11" name="A[0].a11" cname="a11" style="font-weight: bold; text-align: left" />
      </div>
      <div id="apDiv45">
        <input :value="aBill.a12" name="A[0].a12" cname="a12" style="font-weight: bold; text-align: left" />
      </div>
      <div id="apDiv46">
        <input :value="aBill.a13" name="A[0].a13" cname="a13" style="font-weight: bold; text-align: left" />
      </div>
      <div id="apDiv47">
        <textarea
          :value="bBill.b40"
          name="B[0].b40"
          cname="b40"
          style="font-weight: bold; text-align: left; resize: none"
        ></textarea>
      </div>
    </div>
  </div>
</template>

<script>
import { environment } from '@/utils/oss.env'
export default {
  props: {
    bgDatas: { type: Array, default: () => [] },
  },
  data() {
    return {
      aBill: [],
      bBill: [],
      cachetDate: [],
      aDataList: [],
      bDataList: [],
    }
  },
  mounted() {
    this.initABData()
  },
  methods: {
    initABData() {
      const cacheList = []
      const bDataList = []
      const aDataList = []
      for (const index in this.bgDatas) {
        if (this.bgDatas[index]['a'] !== undefined) {
          this.aBill = this.bgDatas[index]['a']
        } else if (this.bgDatas[index]['c'] !== undefined) {
          const cl = this.bgDatas[index]['c']
          for (const jIndex in cl) {
            const c = cl[jIndex]
            const t = { imgUrl: '', x: '', y: '' }
            t.imgUrl = environment.cacheUrl + c.imgUrl
            t.x = c.x + 'px'
            t.y = c.y + 'px'
            cacheList.push(t)
          }
        } else if (this.bgDatas[index]['b'] !== undefined) {
          this.bBill = this.bgDatas[index]['b'][0]
        }

        this.bDataList = bDataList
        this.aDataList = aDataList
        this.cachetDate = cacheList
      }
    },
  },
}
</script>

<style lang="less" scoped>
.bg {
  background-image: url(~@/assets/odiv_ckd1.jpg);
  width: 850px;
  height: 386px;
  position: relative;
  z-index: 0;
}
#outDiv {
  position: relative;
  width: 850px;
  height: 386px;
  z-index: 1;
  margin: 30px;
  margin-left: 0;
  margin-bottom: 0;
}
#apDiv1 {
  height: 20px;
  left: 108px;
  position: absolute;
  top: 68px;
  width: 234px;
  z-index: 1;
}
#apDiv2 {
  height: 20px;
  left: 355px;
  position: absolute;
  top: 66px;
  width: 34px;
  z-index: 1;
}
#apDiv3 {
  height: 20px;
  left: 410px;
  position: absolute;
  top: 66px;
  width: 20px;
  z-index: 1;
}
#apDiv4 {
  height: 20px;
  left: 452px;
  position: absolute;
  top: 66px;
  width: 28px;
  z-index: 1;
}
#apDiv5 {
  height: 20px;
  left: 709px;
  position: absolute;
  top: 66px;
  width: 70px;
  z-index: 1;
}
#apDiv6 {
  height: 40px;
  left: 115px;
  position: absolute;
  top: 101px;
  width: 164px;
  z-index: 1;
}
#apDiv7 {
  height: 40px;
  left: 370px;
  position: absolute;
  top: 105px;
  width: 115px;
  z-index: 1;
}
#apDiv8 {
  height: 40px;
  left: 535px;
  position: absolute;
  top: 101px;
  width: 115px;
  z-index: 1;
}
#apDiv9 {
  height: 40px;
  left: 705px;
  position: absolute;
  top: 101px;
  width: 90px;
  z-index: 1;
}
#apDiv10 {
  height: 20px;
  left: 40px;
  position: absolute;
  top: 200px;
  width: 62px;
  z-index: 1;
}
#apDiv11 {
  height: 20px;
  left: 110px;
  position: absolute;
  top: 200px;
  width: 176px;
  z-index: 1;
}
#apDiv12 {
  height: 20px;
  left: 315px;
  position: absolute;
  top: 200px;
  width: 40px;
  z-index: 1;
}
#apDiv13 {
  height: 20px;
  left: 368px;
  position: absolute;
  top: 200px;
  width: 74px;
  z-index: 1;
}
#apDiv14 {
  height: 20px;
  left: 442px;
  position: absolute;
  top: 200px;
  width: 85px;
  z-index: 1;
}
#apDiv15 {
  height: 20px;
  left: 529px;
  position: absolute;
  top: 200px;
  width: 85px;
  z-index: 1;
}

#LayerOut {
  position: relative;
  top: 0;
  left: 0;
  z-index: 10;
  width: 850px;
  height: 386px;
}

#outDiv input {
  height: 100%;
}

#apDiv16 {
  height: 20px;
  left: 616px;
  position: absolute;
  top: 200px;
  width: 100px;
  z-index: 1;
}
#apDiv17 {
  height: 20px;
  left: 40px;
  position: absolute;
  top: 223px;
  width: 62px;
  z-index: 1;
}
#apDiv18 {
  height: 20px;
  left: 110px;
  position: absolute;
  top: 223px;
  width: 176px;
  z-index: 1;
}
#apDiv19 {
  height: 20px;
  left: 315px;
  position: absolute;
  top: 223px;
  width: 40px;
  z-index: 1;
}
#apDiv20 {
  height: 20px;
  left: 368px;
  position: absolute;
  top: 223px;
  width: 74px;
  z-index: 1;
}
#apDiv21 {
  height: 20px;
  left: 442px;
  position: absolute;
  top: 223px;
  width: 85px;
  z-index: 1;
}
#apDiv22 {
  height: 20px;
  left: 529px;
  position: absolute;
  top: 223px;
  width: 85px;
  z-index: 1;
}
#apDiv23 {
  height: 20px;
  left: 616px;
  position: absolute;
  top: 223px;
  width: 100px;
  z-index: 1;
}
#apDiv24 {
  height: 20px;
  left: 40px;
  position: absolute;
  top: 246px;
  width: 62px;
  z-index: 1;
}
#apDiv25 {
  height: 20px;
  left: 110px;
  position: absolute;
  top: 246px;
  width: 176px;
  z-index: 1;
}
#apDiv26 {
  height: 20px;
  left: 315px;
  position: absolute;
  top: 246px;
  width: 40px;
  z-index: 1;
}
#apDiv27 {
  height: 20px;
  left: 368px;
  position: absolute;
  top: 246px;
  width: 74px;
  z-index: 1;
}
#apDiv28 {
  height: 20px;
  left: 442px;
  position: absolute;
  top: 246px;
  width: 85px;
  z-index: 1;
}
#apDiv29 {
  height: 20px;
  left: 529px;
  position: absolute;
  top: 246px;
  width: 85px;
  z-index: 1;
}
#apDiv30 {
  height: 20px;
  left: 616px;
  position: absolute;
  top: 246px;
  width: 100px;
  z-index: 1;
}
#apDiv31 {
  height: 20px;
  left: 40px;
  position: absolute;
  top: 269px;
  width: 62px;
  z-index: 1;
}
#apDiv32 {
  height: 20px;
  left: 110px;
  position: absolute;
  top: 269px;
  width: 176px;
  z-index: 1;
}
#apDiv33 {
  height: 20px;
  left: 315px;
  position: absolute;
  top: 269px;
  width: 40px;
  z-index: 1;
}
#apDiv34 {
  height: 20px;
  left: 368px;
  position: absolute;
  top: 269px;
  width: 74px;
  z-index: 1;
}
#apDiv35 {
  height: 20px;
  left: 442px;
  position: absolute;
  top: 269px;
  width: 85px;
  z-index: 1;
}
#apDiv36 {
  height: 20px;
  left: 529px;
  position: absolute;
  top: 269px;
  width: 85px;
  z-index: 1;
}
#apDiv37 {
  height: 20px;
  left: 616px;
  position: absolute;
  top: 269px;
  width: 100px;
  z-index: 1;
}
#apDiv38 {
  height: 20px;
  left: 315px;
  position: absolute;
  top: 300px;
  width: 40px;
  z-index: 1;
}
#apDiv39 {
  height: 20px;
  left: 368px;
  position: absolute;
  top: 300px;
  width: 74px;
  z-index: 1;
}
#apDiv40 {
  height: 20px;
  left: 442px;
  position: absolute;
  top: 300px;
  width: 85px;
  z-index: 1;
}
#apDiv41 {
  height: 20px;
  left: 529px;
  position: absolute;
  top: 300px;
  width: 85px;
  z-index: 1;
}
#apDiv42 {
  height: 20px;
  left: 616px;
  position: absolute;
  top: 300px;
  width: 100px;
  z-index: 1;
}
#apDiv43 {
  height: 20px;
  left: 190px;
  position: absolute;
  top: 340px;
  width: 100px;
  z-index: 1;
}
#apDiv44 {
  height: 20px;
  left: 343px;
  position: absolute;
  top: 340px;
  width: 100px;
  z-index: 1;
}
#apDiv45 {
  height: 20px;
  left: 500px;
  position: absolute;
  top: 340px;
  width: 100px;
  z-index: 1;
}
#apDiv46 {
  height: 20px;
  left: 670px;
  position: absolute;
  top: 340px;
  width: 100px;
  z-index: 1;
}
#apDiv47 {
  height: 125px;
  left: 700px;
  position: absolute;
  top: 200px;
  width: 90px;
  z-index: 1;
}
input {
  font-family: 'å®‹ä½“';
  font-size: 12px;
  background-color: transparent;
  background: none;
  constter-spacing: 0px;
  word-spacing: normal;
  border: 1px none #cccccc;
  overflow: hidden;
  width: 99%;
  background-color: transparent;
}
TEXTAREA {
  font-family: 'å®‹ä½“';
  font-size: 12px;
  background-color: transparent;
  background: none;
  constter-spacing: 0px;
  word-spacing: normal;
  border: 1px none #cccccc;
  overflow: hidden;
  width: 99%;
  height: 100%;
}
</style>
